import { Map, TileLayer as TileLayerEntity } from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { useRef } from 'react';
import { MapContainer, TileLayer } from 'react-leaflet';
import { DialogWaterLevel } from 'src/modules/mizusaki/components/DialogWaterLevel.component';
import { MAPBOX_TILE_LAYER_PROPS } from 'src/redux/slices/baseLayer.slice';
import { TileLayerControlTopRight } from './TileLayerControlTopRight.component';
import { LeafletProps } from './types/leaflet-props.type';
import '../../mizusaki/styles/LeafletMizusaki.css';
export function LeafletMizusaki({ mapContainerProps }: LeafletProps) {
  const baseTileLayer = useRef<TileLayerEntity>(new TileLayerEntity(''));
  const map = useRef<Map>(null);
  const mapStyle = {
    width: '100vw',
    ...mapContainerProps?.style,
  };

  return (
    <>
      <DialogWaterLevel />
      <MapContainer attributionControl={false} {...mapContainerProps} style={mapStyle} ref={map}>
        <TileLayer {...MAPBOX_TILE_LAYER_PROPS} ref={baseTileLayer} maxNativeZoom={18} />
        <TileLayerControlTopRight baseTileLayer={baseTileLayer} map={map} />
      </MapContainer>
    </>
  );
}
